import React from 'react';
import './TypingIndicator.css';

const TypingIndicator = () => {
  return (
    <div className="typing-indicator-wrapper">
      <div className="message-avatar">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
          <circle cx="18" cy="18" r="18" fill="#1DB9AA"/>
          <path d="M18 10C18 10 15 10 13 12C11 14 11 18 11 18V23C11 23 11 24.5 12.5 24.5H23.5C23.5 24.5 25 24.5 25 23V18C25 18 25 14 23 12C21 10 18 10 18 10Z" fill="white"/>
          <rect x="15.5" y="19.5" width="5" height="1.5" fill="#1DB9AA"/>
          <circle cx="15.5" cy="16.5" r="1" fill="#1DB9AA"/>
          <circle cx="20.5" cy="16.5" r="1" fill="#1DB9AA"/>
        </svg>
      </div>
      <div className="typing-indicator">
        <span className="typing-dot"></span>
        <span className="typing-dot"></span>
        <span className="typing-dot"></span>
      </div>
    </div>
  );
};

export default TypingIndicator;

